module.exports = __webpack_public_path__ + "img/clearview.6d41f014.png";